module.exports = require("lodash");


//////////////////
// WEBPACK FOOTER
// external "lodash"
// module id = 43
// module chunks = 0


// WEBPACK FOOTER //
// webpack:/external "lodash"